export const PAGE_SIZE_OPTIONS = [5, 10, 25] as const
export const DEFAULT_PAGE_SIZE = 10

export const getPageNumbers = (
  currentPage: number,
  totalPages: number
): (number | 'ellipsis')[] => {
  const siblings = 1
  const start = Math.max(1, currentPage - siblings)
  const end = Math.min(totalPages, currentPage + siblings)
  const pageRange = Array.from({ length: end - start + 1 }, (_, i) => start + i)

  const pages: (number | 'ellipsis')[] = []

  if (start > 1) {
    pages.push(1)
    if (start > 2) pages.push('ellipsis')
  }

  pages.push(...pageRange)

  if (end < totalPages) {
    if (end < totalPages - 1) pages.push('ellipsis')
    pages.push(totalPages)
  }

  return pages
}
